import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Check, Plus } from "lucide-react";

// Searchable brand picker with an "Other brand" free-text option at the bottom.
export function BrandCombobox({ brands = [], value, onChange, testid, placeholder = "Search brand…" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const query = q.trim();
  const filtered = brands.filter((b) => b.toLowerCase().includes(query.toLowerCase()));
  const exact = brands.some((b) => b.toLowerCase() === query.toLowerCase());
  const pick = (name) => { onChange(name); setOpen(false); setQ(""); };

  return (
    <div className="relative" ref={ref}>
      <button type="button" data-testid={testid} onClick={() => setOpen((o) => !o)}
        className="h-11 w-full px-3 rounded-xl border-2 border-line bg-white text-sm flex items-center justify-between gap-1 text-left">
        <span className={value ? "text-ink truncate" : "text-ink-muted"}>{value || "Select brand"}</span>
        <ChevronDown size={15} className="text-ink-muted shrink-0" />
      </button>
      {open && (
        <div className="absolute z-[60] mt-1 w-full max-h-64 overflow-y-auto rounded-2xl border-2 border-line bg-white shadow-lift p-1.5">
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder}
            data-testid={testid ? `${testid}-search` : undefined}
            className="w-full h-9 px-3 mb-1 rounded-lg border border-line bg-cream text-sm outline-none focus:border-brand" />
          {filtered.map((b) => (
            <button key={b} type="button" onClick={() => pick(b)} data-testid={testid ? `${testid}-opt` : undefined}
              className="w-full text-left px-3 py-2 rounded-lg text-sm hover:bg-blush flex items-center justify-between">
              <span className="truncate">{b}</span> {value === b && <Check size={14} className="text-brand shrink-0" />}
            </button>
          ))}
          {query && !exact && (
            <button type="button" onClick={() => pick(query)} data-testid={testid ? `${testid}-other` : undefined}
              className="w-full text-left px-3 py-2 rounded-lg text-sm text-brand font-semibold hover:bg-blush flex items-center gap-1.5 border-t border-line mt-1">
              <Plus size={14} /> Use "{query}" (other brand)
            </button>
          )}
          {filtered.length === 0 && !query && <p className="px-3 py-2 text-xs text-ink-muted">Type to search, or enter your own brand.</p>}
        </div>
      )}
    </div>
  );
}
